<template>
  <div>
    <template v-if="!$vuetify.breakpoint.smAndDown">
      <v-content class="pa-0 chat-main">
        <transition>
          <router-view></router-view>
        </transition>
      </v-content>
    </template>
    <template v-else>
      <Toolbar></Toolbar>
      <v-content class="chat-main">
        <transition>
          <router-view></router-view>
        </transition>
      </v-content>
      <v-bottom-nav :value="true" absolute color="primary" app fixed>
        <v-btn dark flat to="/chat/messaging" v-if="$route.params.uuid">
          <span>Verhandlungen</span>
          <v-icon>chat</v-icon>
        </v-btn>
        <v-btn dark flat @click="logout" v-else>
          <span>Logout</span>
          <v-icon>exit_to_app</v-icon>
        </v-btn>
      </v-bottom-nav>
    </template>
  </div>
</template>

<script>
/**
 * In this file responsivity is handled. The design changes if
 * window is too small. See v-if in html above
 */
import Toolbar from '@/components/Toolbar'
export default {
  components: {
    Toolbar
  },
  methods: {
    logout () {
      window.getApp.$emit('APP_LOGOUT')
    }
  }
}
</script>
